import styled from 'styled-components';
import theme from 'styles/theme';

const Wrapper = styled.div`
  margin: 2.55rem 0 1.55rem;
  position: relative;
  width: 100%;

  .election-hub__search-filter {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .election-hub__search-filter-searcher {
      border: 1px #b1b1b1 solid;
      border-radius: 2px 2px;
      display: inline-block;
      max-width: 100%;
      position: relative;
      width: 350px;

      .election-hub__search-filter--textfield {
        border: none;
        font-size: 1rem;
        font-weight: bold;
        max-height: 42px;
        outline: none;
        padding: 12px 10px;
        width: calc(100% - 55px);

        &::placeholder {
          color: ${theme.black};
          font-family: ${theme.fontSourceSansPro};
          font-weight: bold;
        }

        &:focus {
          outline: none;
        }
      }

      .election-hub__search-filter--magnifying-glass {
        display: inline-block;
        line-height: 0;
        right: 15px;
        top: 10px;
        position: absolute;
        vertical-align: middle;
        width: 20px;

        svg {
          font-size: 10px;
        }
      }

      .election-hub__search-filter--auto-complete-wrapper {
        border: 1px #b1b1b1 solid;
        background-color: #ffffff;
        font-size: 1rem;
        margin-left: -1px;
        outline: none;
        position: absolute;
        user-select: none;
        width: calc(100% + 2px);
        z-index: 1;

        .election-hub__search-filter--auto-complete-option {
          font-family: ${theme.fontAccent};
          font-weight: bold;
          padding: 12px 10px;
          width: calc(100% + 1px);

          &:hover {
            background-color: #9b9b9b;
            color: #ffffff;
            cursor: default;
            outline: none;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }

    @media screen and (max-width: 652px) {
      display: inline-block;
      width: 100%;

      .election-hub__search-filter-searcher {
        display: inline-block;
        width: 100%;
      }

      .election-hub__search-filter-clear-filter  {
        position: relative;
      }
    }
  }

  .election-hub__search-filter-clear-filter {
    color: ${theme.black};
    font-family: ${theme.fontSourceSansPro};
    font-size: 0.85rem;
    font-weight: bold;
    margin-top: 10px;
    outline: none;
    position: relative;
    text-transform: uppercase;
    top: 10px;
    user-select: none;

    &:hover {
      cursor: pointer;
    }

    &:active {
      color: ${theme.black};
    }

    &:focus {
      outline: none;
    }
  }

  .election-hub__search-filter-clear--caret {
    display: inline-block;
    left: 0.4em;
    position: relative;
    vertical-align: baseline;
    width: 0.5em;
  }

  .election-hub__search-filter-no-match {
    color: #d23e24;
    display: block;
    margin-top: 10px;
    word-wrap: break-word;
  }
`;

export default {
  Wrapper,
};
